import styles from "@/components/splash-screen.module.css";
import clsx from "clsx";
import { t } from "i18next";
import { JSX } from "react";

function SplashScreen(): JSX.Element {
	return (
		<div className={styles["splash-screen"]}>
			<div>
				<div className={clsx("app-icon", styles["app-icon"])}></div>
				<div className={styles["app-name"]}>{t("rthWebHosting")}</div>
				<div className={styles["progress-bar-wrapper"]}>
					<div className={styles["progress-bar"]}></div>
				</div>
			</div>
		</div>
	);
}

export default SplashScreen;
